class headerSearchExtendNew extends HTMLElement {
  constructor() {
    super();
    this.searchOpenButton = this.querySelector('[data-search-open]');
    this.searchCloseButton = this.querySelector('[data-search-close]');
    this.searchPopup = this.querySelector('[data-search-popup]');
    this.searchPopupInner = this.searchPopup?.querySelector('.header-search-popup__inner');
    this.searchResults = this.querySelector('[data-search-results]');
    this.searchForm = this.querySelector('predictive-search');
  }

  connectedCallback() {
    this.searchOpenButton.addEventListener('click', this.openSearchPopup.bind(this));
    this.searchCloseButton.addEventListener('click', this.closeSearchPopup.bind(this));
    this.searchPopup.addEventListener('click', (event) => {
      if (event.target === this.searchPopup) {
        this.closeSearchPopup();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.code === 'Escape') {
        this.closeSearchPopup();
      }
    });
  }

  openSearchPopup(event) {
    event.preventDefault();
    if (this.searchPopup) {
      this.searchPopup.classList.remove('invisible', 'opacity-0');
      this.searchPopup.classList.add('visible', 'opacity-100');
      this.searchPopupInner?.classList.remove('translate-x-full');
      this.searchPopupInner?.classList.add('translate-x-0');
      if (window.innerWidth > 1199) {
        if (this.querySelector('#predictive-search-results')) return;
        this.searchForm.showDefaultSuggestions();
      }
    }

    this.lockScroll();
  }

  closeSearchPopup() {
    if (this.searchPopup) {
      this.searchPopup.classList.remove('opacity-100');
      this.searchPopup.classList.add('opacity-0');
      this.searchPopupInner?.classList.remove('translate-x-0');
      this.searchPopupInner?.classList.add('translate-x-full');
      if (this.searchResults.querySelector('.predictive-search-default')) this.searchResults.innerHTML = '';

      setTimeout(() => {
        this.searchPopup.classList.remove('visible');
        this.searchPopup.classList.add('invisible');
        this.unlockScroll();
      }, 350);
    }
  }

  lockScroll() {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox) {
      document.body.style.overflow = 'hidden';
    } else {
      const scrollY = window.scrollY;
      document.body.dataset.scrollY = scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overscrollBehavior = 'none';
    }
  }

  unlockScroll() {
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox) {
      document.body.style.overflow = 'auto';
    } else {
      const scrollY = document.body.dataset.scrollY || '0';
      document.body.removeAttribute('style');
      window.scrollTo({
        top: parseInt(scrollY, 10),
        behavior: 'instant',
      });
    }
  }
}

if (!customElements.get('header-search-extend-new')) {
  customElements.define('header-search-extend-new', headerSearchExtendNew);
}
